export const PACKAGE_NAME = 'jiraServicedeskStandardToPremiumModal';
export const TEAM_NAME = 'itops-mithril';
export const CCP_AGG_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
